module.exports = __webpack_public_path__ + "static/images/y-shcly.34605b2.png";